<template>
  <div class="nodata">
    <div class="nodata__wrap">
      <img src="@/static/images/NoData.png" alt=""/>
      <p v-html="titleErrorMessage"></p>
      <p :class="[userTheme ? `text-${userTheme}` : '']" v-if="errorMessage" v-html="errorMessage"></p>
      <p :class="[userTheme ? `text-${userTheme}` : '']" v-else>請先進行條件搜尋，以產生搜尋資料</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'NoData',
  props: {
    titleErrorMessage: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
    },
  },
  computed: {
    ...mapGetters('userInfo', ['userStyle']),
    ...mapState('userInfo', ['userInfo']),
    userTheme() {
      let theme = '';
      if (this.userInfo.userStyle) {
        theme = this.userInfo.userStyle;
      }
      return theme;
    },
  },
};
</script>

<style lang="scss" scoped >
.nodata{
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;

  &__wrap{

    margin: auto;
    margin-top: 10rem;

    p{
      font-size: 18px;
      color: $secondary;
      &:nth-child(3){
        color:  $primaryColor1;
        font-weight: bolder;

      }
    }
  }

}
</style>
